import { render, staticRenderFns } from "./NewsChangelog.html?vue&type=template&id=eb501524&external"
import script from "./NewsChangelog.ts?vue&type=script&lang=ts&external"
export * from "./NewsChangelog.ts?vue&type=script&lang=ts&external"
import style0 from "./NewsChangelog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports